import { defineMessages } from 'react-intl';

/**
 * Shared "Explore" chip label. Lives outside Chat and `src/components/ui`
 * so the homepage can reuse the in-session message id (and its Crowdin
 * translations) without a new Chat → ui import.
 */
export const EXPLORE_VERB_LABEL = defineMessages({
  explore: {
    defaultMessage: 'Explore',
    id: 'nmIj0Ngvz6',
    description:
      'Verb chip replacing Treat; retrieval-oriented wording in every market (TGA / EU MDR)',
  },
}).explore;
